export const DEFAULT_MAX_NUM_USERS = 3;
export const OVERLAP = 5;
